import { runtimeEnv } from 'config/runtimeEnv';
import { setCurrentUser } from '../utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

// Handle extension request action (Approve)
export const handleExtensionRequestAction = async (requestId, action) => {
  try {
    const res = await requestInstance
      .put(`${env}${API_ENDPOINT.reservation.extensionRequestApi}/${requestId}`, { action })
      .catch((err) => {
        console.error('Extension Request API Error Response:', err.response);
        return err.response;
      });

    console.log('Extension Request Response:', res);
    return setCurrentUser(res);
  } catch (err) {
    console.error('Extension Request Action API Error:', err);
    return err?.response;
  }
};

// Provision new trip for extension
export const provisionNewTripForExtension = async (tripId) => {
  try {
    const res = await requestInstance
      .post(`${env}${API_ENDPOINT.reservation.provisionTripApi}/${tripId}`)
      .catch((err) => {
        console.error('Provision New Trip API Error Response:', err.response);
        return err.response;
      });

    console.log('Provision New Trip Response:', res);
    return setCurrentUser(res);
  } catch (err) {
    console.error('Provision New Trip API Error:', err);
    return err?.response;
  }
};
